import React from 'react';

const Area = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" ref={svgRef} { ...{ ...{width: "1em", height: "1em"}, ...props } }>
    <title>{title}</title>
    <defs>
      <path id="area_a" d="M243 1415a8 8 0 0 0 0 16 8 8 0 0 0 0-16m0 14.12a6.14 6.14 0 1 1 0-12.27 6.14 6.14 0 0 1 0 12.27" />
      <path id="area_b" d="M243 1420.78a2.22 2.22 0 1 0 0 4.45 2.22 2.22 0 0 0 0-4.45" />
    </defs>
    <use fill="currentColor" xlinkHref="#area_a" transform="translate(-235 -1415)" />
    <use fill="currentColor" xlinkHref="#area_b" transform="translate(-235 -1415)" />
  </svg>
);

export default Area;



// WEBPACK FOOTER //
// ./src/common/icons/Area.js